import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import common_fr from "./translations/fr.json";
import common_en from "./translations/en.json";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: common_en,
            },
            fr: {
                translation: common_fr
            },
        },
        lng: "fr",

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
export default i18n;
